/** Local date helpers — avoids IST/UTC shifts from toISOString() */

export const formatLocalDate = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : parseLocalDate(date);
  if (!d || Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  
  if (typeof dateStr === 'string' && dateStr.includes('T')) {
    const d = new Date(dateStr);
    if (!Number.isNaN(d.getTime())) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0);
    }
  }

  const s = String(dateStr).slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 12, 0, 0, 0);
};

/** Normalize to yyyy-MM-dd for API / database */
export const toDateString = (date) => {
  if (!date) return '';
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  if (typeof date === 'string' && date.includes('T')) {
    return formatLocalDate(new Date(date));
  }
  if (date instanceof Date) {
    return formatLocalDate(date);
  }
  return formatLocalDate(parseLocalDate(date));
};

/** Nights stayed: check-in inclusive, check-out exclusive (hotel standard) */
export const calculateNights = (checkIn, checkOut) => {
  const inDate = parseLocalDate(toDateString(checkIn));
  const outDate = parseLocalDate(toDateString(checkOut));
  if (!inDate || !outDate) return 1;
  const nights = Math.round((outDate - inDate) / (1000 * 3600 * 24));
  return nights > 0 ? nights : 0;
};

export const validateStayDates = (checkIn, checkOut) => {
  const checkInStr = toDateString(checkIn);
  const checkOutStr = toDateString(checkOut);
  const inDate = parseLocalDate(checkInStr);
  const outDate = parseLocalDate(checkOutStr);

  if (!checkInStr || !checkOutStr || !inDate || !outDate) {
    return { valid: false, message: 'Please select check-in and check-out dates.' };
  }

  if (outDate <= inDate) {
    return { valid: false, message: 'Check-out date must be later than check-in date.' };
  }

  const numberOfNights = calculateNights(checkInStr, checkOutStr);
  if (numberOfNights < 1) {
    return { valid: false, message: 'Stay must be at least one night.' };
  }

  return { valid: true, checkInStr, checkOutStr, numberOfNights };
};

export const formatDisplayDate = (dateStr) => {
  const d = parseLocalDate(toDateString(dateStr));
  if (!d) return 'N/A';
  return d.toLocaleDateString('en-IN', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const startOfToday = () => {
  const t = new Date();
  t.setHours(12, 0, 0, 0);
  return t;
};

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};
